import { CheckboxSkeleton } from '../CheckboxSkeleton'

import { CHECKBOX_GROUP_SKELETON_ROWS_LENGTH } from './CheckboxGroupSkeleton.constants'

function CheckboxGroupSkeleton({
  className,
  rowsLength = CHECKBOX_GROUP_SKELETON_ROWS_LENGTH,
}) {
  return (
    <div className={className}>
      {Array.from({ length: rowsLength }).map((_, index) => (
        <CheckboxSkeleton key={index} />
      ))}
    </div>
  )
}

export default CheckboxGroupSkeleton
